import React, { useState, useEffect } from 'react';

const cor = '#B51013';

export default function InstalarPWA() {
  const [prompt, setPrompt] = useState(null);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisivel(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setVisivel(false);
    setPrompt(null);
  };

  if (!visivel) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '16px', left: '50%', transform: 'translateX(-50%)',
      background: '#1a1a1a', color: '#fff', borderRadius: '12px',
      padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px',
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)', zIndex: 9999, maxWidth: '360px', width: 'calc(100% - 32px)',
    }}>
      <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: '900', color: '#fff', flexShrink: 0 }}>J</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>Instalar Jatear LMS</div>
        <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.65)' }}>Acesso rápido na tela inicial</div>
      </div>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button onClick={() => setVisivel(false)} style={{ padding: '6px 10px', background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '6px', color: 'rgba(255,255,255,0.7)', fontSize: '12px', cursor: 'pointer' }}>
          Agora não
        </button>
        <button onClick={instalar} style={{ padding: '6px 12px', background: cor, border: 'none', borderRadius: '6px', color: '#fff', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
          Instalar
        </button>
      </div>
    </div>
  );
}
